// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBarArrow_side_arrow_box__\\+pdtP {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 22px;
    cursor: pointer;
}

.SideBarArrow_side_arrow_close__PYtOk {
    width: 4px;
    height: 21px;
}

.SideBarArrow_side_arrow_open__bhlaL {
    width: 8px;
    height: 22px;
}

.ant-message .ant-message-notice {
    margin-left: 215px !important;
    transition: margin 0.5s;
}

.ant-message-custom-margin-right .ant-message-notice {
    margin-left: 0 !important;
    margin-right: 56px !important;
    transition: margin 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideBarArrow/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;AAC3B","sourcesContent":[".side_arrow_box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 100%;\n    height: 22px;\n    cursor: pointer;\n}\n\n.side_arrow_close {\n    width: 4px;\n    height: 21px;\n}\n\n.side_arrow_open {\n    width: 8px;\n    height: 22px;\n}\n\n:global(.ant-message .ant-message-notice) {\n    margin-left: 215px !important;\n    transition: margin 0.5s;\n}\n\n:global(.ant-message-custom-margin-right .ant-message-notice) {\n    margin-left: 0 !important;\n    margin-right: 56px !important;\n    transition: margin 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"side_arrow_box": `SideBarArrow_side_arrow_box__+pdtP`,
	"side_arrow_close": `SideBarArrow_side_arrow_close__PYtOk`,
	"side_arrow_open": `SideBarArrow_side_arrow_open__bhlaL`
};
export default ___CSS_LOADER_EXPORT___;
